import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { tagHotjarRecording } from '../../../helpers/util'
import useHome from '../../../hooks/useHome'
import InputText from '../../../components/InputText/InputText'
import { useFormik } from 'formik'
import { initialValues, validationSchema } from '../../../forms/SignUpForm'
import InputPhoneNumber from '../../../components/InputText/components/InputPhoneNumber'
import Button from '../../../components/Button/Button'
import clsx from 'clsx'
import useGlobalLoading from '../../../hooks/useGlobalLoading'

const SignUpForm = ({ defaults, setSignUpSuccess }) => {
    const [error, setError] = useState('')
    //const [formSuccess, setFormSuccess] = useState(false)
    const { handleRequestNewAccount } = useHome()
    const { changeLoading } = useGlobalLoading()

    const {
        isValid,
        setSubmitting,
        setFieldValue,
        getFieldProps,
        values,
        isSubmitting,
        touched,
        handleSubmit,
    } = useFormik({
        initialValues: initialValues(defaults),
        validationSchema,
        onSubmit: async formValues => {
            setSubmitting(true)
            onSubmit(formValues)
            setSubmitting(false)
        },
    })

    useEffect(() => {
        if (defaults) {
            Object.keys(defaults)?.forEach(e => setFieldValue(e, defaults[e]))
        }
    }, [defaults])

    useEffect(() => {
        if (!isValid && Object.keys(touched).length > 0) {
            setError('All fields are required')
        } else {
            setError('')
        }
    }, [isValid, touched])

    const onNewAccountRequested = () => {
        setSignUpSuccess(true)
        changeLoading(false)
        //setError('')
        //setFormSuccess(true)
    }

    const renderErrors = () => {
        if (typeof error === 'string') {
            return (
                <p
                    className={clsx(
                        'transition-all delay-200  text-error font-medium text-sm',
                    )}
                >
                    {error}
                </p>
            )
        }
        return (
            typeof error === 'object' && (
                <div className="w-full h-auto flex items-center justify-center flex-col gap-y-1 mt-4">
                    {error?.map((item, index) => {
                        return (
                            <p
                                key={`error-${index}`}
                                className={clsx(
                                    'transition-all delay-200  text-error font-medium text-sm',
                                )}
                            >
                                {item}
                            </p>
                        )
                    })}
                </div>
            )
        )
    }

    const onNewAccountRequestError = err => {
        tagHotjarRecording('API Error')
        const { errors } = err?.response?.data ?? {}

        if (errors) {
            const listOfErrors = Object.keys(errors).map((key, i) => {
                return (
                    <span key={i}>
                        {errors[key][0]}
                        <br />
                    </span>
                )
            })
            setError(listOfErrors)
        } else {
            setError('Error')
        }
        changeLoading(false)
    }

    const onSubmit = values => {
        changeLoading(true)
        return handleRequestNewAccount(
            {
                ...values,
                phone_country_id: '+1',
                phone: values?.phone?.replace('+1 ', ''),
            },
            onNewAccountRequested,
            onNewAccountRequestError,
        )
    }

    return (
        <form
            onSubmit={handleSubmit}
            className="w-full h-auto flex flex-col items-center justify-start gap gap-y-2 transition-all"
        >
            <div className="w-full h-auto flex sm:flex-row flex-col items-center justify-between gap-x-6">
                <InputText
                    variant="black"
                    {...getFieldProps('firstName')}
                    label="First Name"
                    value={values?.firstName}
                />
                <InputText
                    variant="black"
                    {...getFieldProps('lastName')}
                    label="Last Name"
                    value={values?.lastName}
                />
            </div>
            <div className="w-full h-auto flex sm:flex-row flex-col items-center justify-between gap-x-6">
                <InputText
                    variant="black"
                    {...getFieldProps('email')}
                    label="Email Address"
                    value={values?.email}
                />
                <InputPhoneNumber
                    variant="black"
                    {...getFieldProps('phone')}
                    placeholder="(111) 555-7777"
                    label="Phone Number"
                    onChange={value => setFieldValue('phone', value)}
                    value={values?.phone}
                />
            </div>

            <InputText
                {...getFieldProps('company')}
                variant="black"
                additionalClass="w-full"
                label="Company Name"
                value={values?.company}
            />
            <InputText
                variant="black"
                {...getFieldProps('address')}
                additionalClass="w-full"
                label="Address"
                value={values?.address}
            />

            <Button
                text="Send Request"
                type="submit"
                variant="secondary"
                disabled={
                    isSubmitting ||
                    (!isValid && Object.keys(touched).length > 0)
                }
                className="w-full"
            />
            {renderErrors()}
        </form>
    )
}

SignUpForm.propTypes = {
    defaults: PropTypes.shape({
        company: PropTypes.string,
    }),
    setSignUpSuccess: PropTypes.func,
}

const RoutedSignUpForm = withRouter(SignUpForm)

export default RoutedSignUpForm
